<div class="auth-container">
  <div class="background-elements">
    <svg
      class="hexagon polygon"
      viewBox="0 0 901 937"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.2"
        d="M1.32987 311.604L361.502 1.13669L810.461 157.821L899.248 624.973L539.075 935.441L90.1166 778.756L1.32987 311.604Z"
        stroke="white"
        stroke-width="2" />
    </svg>

    <svg
      class="circle polygon"
      viewBox="0 0 1061 1061"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        opacity="0.2"
        cx="530.5"
        cy="530.5"
        r="529.5"
        stroke="white"
        stroke-width="2" />
    </svg>

    <svg
      class="square polygon"
      viewBox="0 0 1102 1102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        opacity="0.2"
        x="703.696"
        y="1.36261"
        width="805.934"
        height="806.745"
        transform="rotate(60.5256 703.696 1.36261)"
        stroke="white"
        stroke-width="2" />
    </svg>
  </div>

  <div class="auth-card">
    <!-- Header avec logo/icône -->
    <div class="auth-header">
      <div class="auth-icon">
        <img src="assets/icons/microsoft-5.svg" alt="logo microsoft" />
      </div>
      <h1 class="auth-title">Authentification en cours</h1>
      <p class="auth-subtitle">Vérification de vos informations...</p>
    </div>

    <!-- Profile Section -->
    @if (profileSiganl()) {
      <div class="profile-section">
        <div class="profile-avatar">
          <img [src]="profilePic" alt="Photo de profil" class="avatar-image" />
        </div>

        <div class="profile-info">
          <h3 class="profile-name">
            {{ profileSiganl().displayName }}
          </h3>
          <p class="profile-email">{{ profileSiganl().mail }}</p>
        </div>
      </div>
    }

    <!-- Loading Animation -->
    <div class="loading-section">
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <p class="loading-text">Finalisation de la connexion...</p>
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Status Messages -->
    <div class="status-messages">
      <div class="status-item">
        <div class="status-icon success">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M20 6L9 17L4 12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <span>Authentification Microsoft réussie</span>
      </div>
      <div class="status-item">
        <div class="status-icon loading">
          <div class="mini-spinner"></div>
        </div>
        <span>Vérification des permissions...</span>
      </div>
    </div>
  </div>
</div>
